export const salutations: Array<{ id: number, displayName: string }> = [
	{ id: 0, displayName: 'Mr.' },
	{ id: 1, displayName: 'Ms.' },
	{ id: 2, displayName: 'Mrs.' },
	{ id: 3, displayName: 'Dr.' },
	{ id: 4, displayName: 'Prof.' }
];
